import Icon from './icon/Icon'
import IconSvg from './icon-svg/IconSvg'

export { Icon, IconSvg }
